<style lang="less">
.app-footer {
  display: none;
}
</style>

<template>
  <div class="app-footer"></div>
</template>
<script>
export default {};
</script>
